import styled from 'styled-components'
import { mdStyle, smStyle, lgStyle } from '@/components/Adapter'

export const MarketRateStyled = styled.div<{ isDark: boolean }>`
  width: 100%;
  height: 100%;
  max-height: 246px;
  box-sizing: border-box;
  padding: 20px 24px;
  border-radius: 8px;
  border: 1px solid var(--color-divider-2);
  max-width: 'calc(100vw - 24px - 2px)';
  background: ${({ isDark }) => (isDark ? `none` : 'var(--color-card-3);')};
  .coin-list-swiper-box {
    display: none;
  }

  &:hover {
    .coin-list-swiper-box {
      display: flex;
    }
  }

  li {
    list-style: none;
  }

  ${mdStyle} {
    width: calc((100% - 32px) / 3);
    height: auto;
    padding: 24px;
  }
`

export const MarketRateTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  strong {
    color: var(--color-pd-2);
  }

  ${mdStyle} {
    flex-direction: column;
    gap: 8px;
    h2 {
      width: 100%;
      text-align: left;
    }
    p {
      width: 100%;
      text-align: left;
    }
  }
  ${lgStyle} {
    flex-direction: row;

    h2 {
      width: auto;
      text-align: left;
    }
    p {
      width: auto;
      text-align: right;
    }
  }
`

export const MarketRateProgressBoxStyled = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  P {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 12px;
    line-height: normal;
  }
  ${mdStyle} {
    margin-top: 12px;
  }
  ${lgStyle} {
    margin-top: 24px;
  }
`
export const MarketRateProgressNumberStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  height: 16px;

  ${mdStyle} {
    margin-top: 4px;
  }

  ${lgStyle} {
    margin-top: 8px;
  }

  span {
    display: flex;
    gap: 4px;
  }
`

export const MarketRateButtonStyled = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;

  flex-direction: row;

  ${mdStyle} {
    flex-direction: column;
  }

  ${lgStyle} {
    margin-top: 24px;
    flex-direction: row;
  }
`

export const ProgressBox = styled.div`
  width: 100%;
  & .mantine-Progress-root,
  & .gui-mantine-rtl-Progress-root {
    & .mantine-Progress-bar:nth-child(1)::before,
    & .gui-mantine-rtl-Progress-bar:nth-child(1)::before {
      content: ' ';
      height: 4px;
      width: 36px;
      position: absolute;
      right: -18px;
      z-index: 9;
      background: var(--color-bg-1);
      transform: rotate(90deg);
    }
    & .gui-mantine-rtl-Progress-bar:nth-child(1)::before {
      right: unset;
      left: -18px;
    }
  }
  & .number {
    justify-content: space-between;
    font-weight: 500;
    font-size: 28px;
    line-height: 28px;
    color: var(--color-funct-2);
  }
  & .red {
    color: var(--color-funct-3);
  }
  & .label {
    justify-content: space-between;
    line-height: 1;
    color: var(--color-text-2);
    font-size: 12px;
    ${smStyle} {
      font-size: 14px;
    }
  }
`
